
import React from "react";
import { Logo } from "@/components/ui/logo";
import { Button } from "@/components/ui/button";
import { Bell, User } from "lucide-react";
import { HossButton } from "@/components/ui/hoss-button";
import { useAuth } from "@/contexts/AuthContext";

interface HossHeaderProps {
  userName?: string;
  onMenuToggle?: () => void;
}

export const HossHeader: React.FC<HossHeaderProps> = ({
  userName,
  onMenuToggle
}) => {
  const { user } = useAuth();
  
  // Use provided prop or fall back to user context data
  const displayName = userName || user?.name || "Hoss Immo";
  const displayEmail = user?.email || "work@hoss-immo.de";
  
  return (
    <header className="w-full bg-white border-b border-gray-100 shadow-sm z-10">
      <div className="container mx-auto px-4">
        <div className="flex items-center justify-between h-16">
          <div className="flex items-center">
            <div className="ml-4">
              <h1 className="text-2xl font-semibold text-[#417F96]">
                Willkommen im Kundenportal,
              </h1>
              <p className="text-gray-600 text-sm">Professionelle Immobilienberatung</p>
            </div>
          </div>
          
          <div className="flex items-center space-x-6">
            <HossButton variant="default">
              Rückruf vereinbaren
            </HossButton>
            
            <div className="relative">
              <Button variant="ghost" size="icon" className="text-[#417F96]">
                <Bell size={20} />
                <span className="absolute top-1 right-1 w-5 h-5 flex items-center justify-center rounded-full bg-[#41c7f0] text-white text-xs">2</span>
              </Button>
            </div>
            
            <div className="flex items-center space-x-3">
              <div className="text-right">
                <p className="font-medium text-[#417F96]">{displayName}</p>
                <p className="text-sm text-gray-500">{displayEmail}</p>
              </div>
              <div className="h-10 w-10 rounded-full flex items-center justify-center bg-[#417F96] text-white">
                {displayName.charAt(0)}
              </div>
            </div>
          </div>
        </div>
      </div>
    </header>
  );
};
